import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  panel: {
    border: 'none',
    padding: '0px 15px'
  },
  heading: {
    fontWeight: 'bold'
  },
  listItem: {
    color: '#000000',
    fontSize: '13px',
    paddingTop: '8px',
    fontWeight: 'lighter',
    borderBottom: 'none'
  },
  panelDetailsRoot: {
    padding: 0,
    display: 'block'
  },
  priceDetails: {
    minWidth: '200px',
    display: 'flex',
    alignItems: 'center'
  },
  unitTitle: {
    padding: '5px 16px',
    fontWeight: 'bold'
  },
  summarySubheader: {
    lineHeight: '24px',
    fontSize: '10px',
    fontWeight: 'bold',
    textTransform: 'uppercase'
  },
  total: {
    fontWeight: 'bold',
    fontSize: '15px'
  },
  totalContainer: {
    display: 'flex',
    minWidth: '200px',
    paddingTop: '10px'
  },
  totalPriceContainer: {
    paddingLeft: '30px',
    paddingTop: '10px',
    display: 'flex',
    alignItems: 'baseline'
  },
  subheader: {
    display: 'flex',
    alignItems: 'baseline'
  },
  currency: {
    marginTop: '4px',
    fontSize: '10px'
  }
});

export default useStyles;
